import request from "@/utils/request";

// 列表(主数据列表)
export function loadCommissionedOrderListDataApi(data) {
  return request({
    url: "web/materialsCommissionedOrder/listData",
    method: "post",
    data,
  });
}
// 导出
export function loadCommissionedOrderExportDataApi(data) {
  return request({
    url: "web/materialsCommissionedOrder/exportData",
    method: "post",
    data,
  });
}
// 初始化
export function initCommissionedOrderApi(data) {
  return request({
    url: "web/materialsCommissionedOrder/init",
    method: "post",
    data,
  });
}
// 新增或修改
export function saveCommissionedOrderApi(data) {
  return request({
    url: "web/materialsCommissionedOrder/save",
    method: "post",
    data,
  });
}
// 作废
export function removeCommissionedOrderApi(data) {
  return request({
    url: "web/materialsCommissionedOrder/remove",
    method: "post",
    data,
  });
}
// 提交
export function submitCommissionedOrderApi(data) {
  return request({
    url: "web/materialsCommissionedOrder/submit",
    method: "post",
    data,
  });
}
// 退回
export function backCommissionedOrderApi(data) {
  return request({
    url: "web/materialsCommissionedOrder/back",
    method: "post",
    data,
  });
}
// 复核
export function checkCommissionedOrderApi(data) {
  return request({
    url: "web/materialsCommissionedOrder/check",
    method: "post",
    data,
  });
}
// 撤销复核
export function revokeCommissionedOrderApi(data) {
  return request({
    url: "web/materialsCommissionedOrder/revoke",
    method: "post",
    data,
  });
}
// 发货
export function shipmentCommissionedOrderApi(data) {
  return request({
    url: "web/materialsCommissionedOrder/shipment",
    method: "post",
    data,
  });
}
// 调整价格
export function adjustCommissionedOrderApi(data) {
  return request({
    url: "web/materialsCommissionedOrder/adjust",
    method: "post",
    data,
  });
}

// 获取待处理申请数量
export function countTodoCommissionedOrderApi(data) {
  return request({
    url: "web/materialsCommissionedOrder/countTodoData",
    method: "post",
    data,
  });
}
